<template>
  <div class="about">
    <!-- 反馈 -->
    <Card title="在线反馈  📑">
      <template slot="content">
        <Minput
          icon="icon-wentifankui"
          placeholder="可以反馈任何内容。"
          v-model="content"
        ></Minput>
        <div class="linkme">
          or 你还可以直接
          <span class="link" @click="onLinkAdmin"> 联系站长</span>
        </div>
        <div class="submits">
          <Mbutton
            class="submit-btn"
            :disabled="canISubmit"
            :loading="isloading"
            @click="onSubmit"
          >
            提交</Mbutton
          >
        </div>
      </template>
    </Card>
    <div class="history">
      <div class="title">反馈记录 📜</div>
      <MTable
        :cols="cols"
        :data="data"
        align="center"
        :stripe="true"
        :line="true"
      ></MTable>
      <pagination
        :total="total"
        :currentPage="query.page"
        @pageChange="pageChange"
      ></pagination>
    </div>
  </div>
</template>

<script>
import Card from "@/components/common/Card";
import Minput from "@/components/common/Input";
import Mbutton from "@/components/common/Button";

import Pagination from "@/components/common/Pagination/Pagination.vue";
import MTable from "@/components/common/Table/Table.vue";
import { feedback, getFeedList } from "@/api/user";

export default {
  components: {
    Card,
    Pagination,
    MTable,
    Minput,
    Mbutton,
  },
  data() {
    return {
      total: 10,
      query: {
        pages: 1,
        limit: 10,
      },
      isloading: false,
      content: "",
      cols: [
        {
          label: "index",
          field: "index",
        },
        {
          label: "反馈内容",
          field: "content",
          width: 150,
        },
        {
          label: "状态",
          field: "status",
        },
        {
          label: "回复信息",
          field: "reback",
        },
        {
          label: "创建时间",
          field: "createdTime",
          sort: true,
        },
      ],
      data: [],
    };
  },
  computed: {
    canISubmit: function () {
      return Boolean(this.content) == false;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    onLinkAdmin() {
      const adminqq = "1549072621";
      window.open(
        `http://wpa.qq.com/msgrd?v=3&uin=${adminqq}&site=qq&menu=yes`,
        "_blank"
      );
    },
    pageChange(value) {
      this.query.pages = value;
      this.getData();
    },
    onSubmit() {
      this.isloading = true;
      feedback({ content: this.content })
        .then((res) => {
          this.isloading = false;
          if (res.code === 200) {
            this.$tip.success("提交成功！");
          } else {
            this.$tip.danger("提交失败！");
          }
        })
        .catch((err) => {
          this.$tip.danger("提交失败！");
          this.isloading = false;
          console.log(err);
        });
    },
    getData() {
      getFeedList(this.query).then((res) => {
        this.data = res.data.datas.map((item, index) => ({
          content: item.content,
          status: ["未回复", "已回复"][item.status],
          reback: item.reback || "暂无回复",
          createdTime: item.createdTime,
        }));
        this.total = res.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.about {
  .link {
    display: inline;
    cursor: pointer;
    &:hover {
      color: #5932ea;
    }
  }
  .submits {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .submit-btn {
      text-align: center;
      padding: 0.8rem 1rem;
      width: 10rem;
    }
  }
}
</style>
